export default __webpack_public_path__ + "static/media/17.29c37207.png";